export const documentServerUrl = 'https://front-end-huawei-cdn.devops.cndinfo.com/npm/onlyoffice@7.4.1/api.js'
export const createParams = (
  key,
  url,
  title = 'Document.docx',
  callbackUrl = ''
) => {
  return {
    document: {
      fileType: 'docx',
      key,
      title,
      url
    },
    documentType: 'word',
    'permissions': {
      'comment': true,
      'commentGroups': {
        'edit': ['Group2', ''],
        'remove': [''],
        'view': ''
      },
      'copy': true,
      'deleteCommentAuthorOnly': false,
      'download': true,
      'edit': true,
      'editCommentAuthorOnly': false,
      'fillForms': true,
      'modifyContentControl': true,
      'modifyFilter': true,
      'print': true,
      'review': true,
      'reviewGroups': ['Group1', 'Group2', '']
    },
    editorConfig: {
      lang: 'zh',
      callbackUrl: callbackUrl
    }
  }
}
